import React from "react";
import Grid from "@mui/material/Grid";

/**
 * Arranges a set of buttons to the left with padding in between
 * Typically, can be used to position create and cancel buttons
 * Notes:
 * 1. Expecting at least one buttons
 * 2. Button should not have fullWidth property set. Otherwise, it will occupy the whole width
 * 3. Assuming that this component is part of a larger grid
 *
 */
export default function ButtonGroup({ children }) {
  return (
    <Grid
      item
      xs={12}
      display="flex"
      justifyContent="flex-start"
      columnGap="10px"
    >
      {children}
    </Grid>
  );
}
